// extracted by mini-css-extract-plugin
module.exports = {"jobs__card":"JobCard_jobs__card__2YqTI","card-title":"JobCard_card-title__28K0K"};